import Choices from 'choices.js';
import '../../../../node_modules/choices.js/public/assets/styles/choices.css';

import validator from 'validator';

import { setCookie, getCookie } from './cookies.js';


export const closePopupsButtonWatcher = () => {

	//Close popup
	const closePopupLinksOnPage = document.querySelectorAll('.js__close-popups'); //Get all popup links on page

	if (closePopupLinksOnPage.length > 0) { //Check if there are any links first
		closePopupLinksOnPage.forEach((closePopupLink) => { //Loop through each and give it a onclick event listener
			closePopupLink.addEventListener('click', (event) => {
				event.preventDefault(); //Stop the link firing normally !
				closeAllPopups();

				document.querySelector('body').classList.remove('js__popup-active');
				document.querySelector('body').classList.remove('js__custom-popup-active');
				document.querySelector('#js__body').classList.remove('js__popup-active');
				document.querySelector('#js__body').dataset.popup = '';
			});
		});
	}
}

export const openPopup = (targetPopupID, popupType = null) => {
	var targetPopup = document.querySelector(targetPopupID); //Select the popup
	if (targetPopup) { //Check we have a valid target popup
		console.log('Opening Popup: ' + targetPopupID);
		closeAllPopups()//Make sure no popups are currently open
		targetPopup.classList.add('active'); //Activate the popup!

		document.querySelector('body').classList.add('js__popup-active'); //Add class to body to show popup is open
		document.querySelector('#js__body').classList.add('js__popup-active');

		if (popupType == 'custom') {
			document.querySelector('body').classList.add('js__custom-popup-active');
		}

		document.querySelector('#js__body').dataset.popup = targetPopupID;

		console.log(targetPopupID);
		if (targetPopupID === '#main-nav') {
			const mainNavLinks = document.querySelectorAll('.js__nav-link'); //Get all nav links

			if (mainNavLinks.length > 0) {
				mainNavLinks.forEach((navLink) => {
					if (navLink.classList.contains('current')) {
						const currentNavHoverIndex = navLink.dataset.item;

						if (currentNavHoverIndex) {
							const navImages = document.querySelectorAll('.main-nav__image');

							if (navImages) {
								navImages.forEach((navImage) => {
									if (navImage.dataset.item == currentNavHoverIndex) {
										navImage.classList.add('active');
									} else {
										navImage.classList.remove('active');
									}
								})
							}
						}
					}
				});
			}
		}
	} else {
		console.warn('Missing Popup: ' + targetPopupID);
	}
}


export const closeAllPopups = () => {
	var openPopups = document.querySelectorAll('.popup.active');
	if (openPopups.length > 0) {
		openPopups.forEach((openPopup) => {
			openPopup.classList.remove('active');
		});
	}
	let regionsPopups = document.querySelectorAll('.m__llist__regions');
	if (regionsPopups) {
		regionsPopups.forEach((regionsPopup) => {
			regionsPopup.classList.remove('active');
		})
	}
}



export const hijackDMNForm = () => {

	let igniteDMNWidgets = document.querySelectorAll('.dmn-widget-hijack');

	if (igniteDMNWidgets.length) {
		if (!document.querySelector('#dmn-css')) {
			let dmnLinkTag = document.createElement('link');
			dmnLinkTag.id = 'dmn-css';
			dmnLinkTag.rel = 'stylesheet';
			dmnLinkTag.href = '//onsass.designmynight.com';
			document.head.appendChild(dmnLinkTag);
		}

		igniteDMNWidgets.forEach((igniteDMNWidget) => {
			if (!igniteDMNWidget.dataset.dmnLoaded) {
				let dmnScriptTag = document.createElement('script');
				dmnScriptTag.src = '//widgets.designmynight.com/bookings-partner.min.js';
				dmnScriptTag.setAttribute('dmn-booking-form', '');
				dmnScriptTag.setAttribute('venue', igniteDMNWidget.dataset.venue);
				igniteDMNWidget.dataset.dmnLoaded = 'true';
				igniteDMNWidget.appendChild(dmnScriptTag);
			}
		});
	}

}


export const hijackOTForm = () => {

	let otWidgets = document.querySelectorAll('.popup__ot-booking');
	if (otWidgets) {
		otWidgets.forEach((otWidget) => {
			let otSelect = otWidget.querySelector('.ot-select'),
				otButton = otWidget.querySelector('.js__open-ot');


			if (window.hasOwnProperty('otSelectChoices')) {
				window.otSelectChoices.destroy();
			}

			if (otSelect) {

				let choicesConfig = {
					itemSelectText: '',
					shouldSort: false,
					searchEnabled: false,
				};


				window.otSelectChoices = new Choices(otSelect, choicesConfig);

				otButton.addEventListener('click', (event) => {
					event.preventDefault();



					let otUrl = 'https://www.opentable.com/restref/client/?rid=' + otSelect.value + '&restref=' + otSelect.value + '&ot_source=Restaurant%20website';
					// let locationIframe = document.createElement('iframe');

					// locationIframe.setAttribute('src',otUrl);
					// bookingWidgetIframeWrapper.innerHTML = "";
					// bookingWidgetIframeWrapper.appendChild(locationIframe);
					// bookingWidgetPopup.classList.add('is-active');
					// bookingWidgetPopup.classList.add('is-loading');

					// setTimeout(function () {
					// 	bookingWidgetPopup.classList.remove('is-loading');
					// 	bookingWidgetPopup.classList.add('has-iframe');
					// }, 2000);

					window.open(otUrl, '_blank');
				})

			}
		})
	}

}


export const newsletterSignupForm = () => {
	const newsletterSubmitButton = document.querySelector('.js__signup'),
		newsletterSignupForm = document.querySelector('#newsletter-signup-form'),
		newsletterThankyou = document.querySelector('#js__newsletter-thankyou'),
		newsletterLocationSelect = document.querySelector('#BrandID');
	popup = document.querySelector('.popup#newsletter');
	/* if(newsletterLocationSelect){
		const choicesConfig = {
			itemSelectText: '',
			shouldSort: false,
			searchEnabled: false,
		};		
		newsletterLocationSelectChoices = new Choices(newsletterLocationSelect,choicesConfig);
	} */

	if (newsletterSubmitButton && newsletterSignupForm) {

		newsletterSignupForm.addEventListener('submit', (event) => {
			event.preventDefault();

			newsletterSignupForm.classList.add('submitting');

			grecaptcha.ready(function () {
				grecaptcha.execute(igniteRecaptchaKey, { action: 'newsletterSignupForm' }).then(function (token) {

					let formData = new FormData(newsletterSignupForm);
					let isFormValid = true;

					//Reset any errors
					for (var [key, value] of formData.entries()) {
						// Skip array-style field names (like restaurant[]) and special fields
						if (key != 'locations' && key != 'events' && !key.includes('[]')) {
							let inputToCheck = document.querySelector('#' + key);
							if (inputToCheck && inputToCheck.required) {
								inputToCheck.classList.remove('error');
							}
						}
					}

					//Check for any required fields left blank
					for (var [key, value] of formData.entries()) {
						// Skip array-style field names (like restaurant[]) as they don't have IDs
						if (key.includes('[]')) {
							continue;
						}

						let inputToCheck = document.querySelector('#' + key);

						if (!value || value == '' || value == '#') {
							if (inputToCheck && inputToCheck.required) {
								console.log('test required');
								isFormValid = false;
								inputToCheck.classList.add('error');

								if (key == 'BrandID') {
									alert('Please select a location');
								}
							}
						} else {
							if (inputToCheck) {
								if (inputToCheck.type == 'email') {
									if (!validator.isEmail(value)) {
										isFormValid = false;
										inputToCheck.classList.add('error');
									}
								} else if (inputToCheck.type == 'text') {
									if (!validator.isAscii(value)) {
										isFormValid = false;
										inputToCheck.classList.add('error');
									}
								}
							}
						}
					}




					if (isFormValid) {
						// Check if restaurant checkboxes exist and are checked
						const restaurantCheckboxes = newsletterSignupForm.querySelectorAll('input[name="restaurant[]"]:checked');
						const checkedBrandIDs = Array.from(restaurantCheckboxes).map(checkbox => checkbox.value);

						// If checkboxes are checked, use those BrandIDs; otherwise use the default BrandID
						const defaultBrandID = formData.get('BrandID');
						let brandIDsToProcess = checkedBrandIDs.length > 0
							? checkedBrandIDs
							: (defaultBrandID ? [defaultBrandID] : []);

						// Fallback to BrandID 79 if no BrandID is available
						if (brandIDsToProcess.length === 0) {
							console.warn('No BrandID available for submission, falling back to BrandID 79');
							brandIDsToProcess = ['79'];
						}

						// Create an array of promises for all the AJAX requests
						// Each request needs its own reCAPTCHA token since tokens are single-use
						const submitPromises = brandIDsToProcess.map(brandID => {
							// Generate a new reCAPTCHA token for each request
							return grecaptcha.execute(igniteRecaptchaKey, { action: 'newsletterSignupForm' }).then(function (recaptchaToken) {
								// Create a new FormData for each request with the specific BrandID
								const requestFormData = new FormData(newsletterSignupForm);
								requestFormData.set('BrandID', brandID);
								requestFormData.set('recaptcha', recaptchaToken);

								return fetch(igniteAjax.ajaxurl, {
									method: 'POST',
									body: requestFormData,
								})
									.then(async (response) => {
										// Try to parse as JSON, fall back to text if it fails
										const contentType = response.headers.get('content-type');
										let data;

										if (contentType && contentType.includes('application/json')) {
											data = await response.json();
										} else {
											// Try to parse as JSON, but handle text responses
											const text = await response.text();
											try {
												data = JSON.parse(text);
											} catch (e) {
												// If it's not JSON, treat it as an error message
												data = { ResponseStatus: false, error: text };
											}
										}

										return { brandID, success: data.ResponseStatus || false, data };
									})
									.catch((error) => {
										console.error(`Error submitting for BrandID ${brandID}:`, error);
										return { brandID, success: false, error: error.message || error };
									});
							});
						});

						// Wait for all requests to complete
						Promise.all(submitPromises)
							.then((results) => {
								newsletterSignupForm.classList.remove('submitting');

								// Check if all requests were successful
								const allSuccessful = results.every(result => result.success);

								if (allSuccessful) {
									popup.querySelector('.popup__title').classList.add('hidden');
									newsletterSignupForm.classList.add('hidden');
									newsletterThankyou.classList.remove('hidden');
								} else {
									newsletterSignupForm.classList.remove('hidden');
									newsletterThankyou.classList.add('hidden');
									console.error('Some submissions failed:', results);
								}
							})
							.catch((error) => {
								console.error('Error processing submissions:', error);
								newsletterSignupForm.classList.remove('submitting');
							});
					} else {
						newsletterSignupForm.classList.remove('submitting');
					}
				});
			});

		})

	}
}

export const triggerCustomPopups = () => {
	//Function to launch any custom popups
	let customPopups = document.querySelectorAll('.popup.custom-popup');

	if (customPopups.length > 0) { //Check if there are any links first
		customPopups.forEach((customPopup) => {
			let displayType = customPopup.dataset.type,
				displayPages = customPopup.dataset.pages,
				displayPeriod = customPopup.dataset.period,
				currentPageID = document.querySelector('#js__body').dataset.page,
				triggerPopup = false;


			if (displayType != 'trigger') { //Ignore if manually triggered
				//First check if the visitor already has the cookie, or if the popup is set to always display
				if (displayPeriod == 0) {
					triggerPopup = true;
				} else {
					let hasCookie = getCookie(customPopup.getAttribute('id'));
					if (hasCookie) {
						//User has cookie, don't show the popup
					} else {
						triggerPopup = true;
					}
				}


				//If we're in the trigger period, check to see if we're on the right page
				if (triggerPopup) { //No point continuing if they failed the period check!
					if (displayType == 'all') {
						triggerPopup = true;
					} else if (displayType == 'exclude' && !(displayPages.includes(currentPageID)) && currentPageID != "") {
						triggerPopup = true;
					} else if (displayType == 'include' && displayPages.includes(currentPageID) && currentPageID != "") {
						triggerPopup = true;
					} else {
						triggerPopup = false;
					}
				}

				if (triggerPopup) { //Show the popup and add a cookie if needed
					openPopup('#' + customPopup.getAttribute('id'), 'custom');
					if (displayPeriod > 0) {
						setCookie(customPopup.getAttribute('id'), true, displayPeriod);
					}
				}
			}
		});
	}
}